import 'packery/dist/packery.pkgd'
import Draggabilly from 'draggabilly/draggabilly'

function updateTasksPositionOrder ($container) {
  $container.packery('getItemElements').forEach((el, index) => {
    $(el).find('.boarding_template_entries_position input').val(index + 1)
  })
}

function initDraggabelBoardingTask (task, $container) {
  // new Draggabilly requires a native element; `task` can be a raw element
  // from packery.getItemElements() or a jQuery collection from cocoon:after-insert
  let el
  if (task && task.nodeType === 1) {
    el = task
  } else if (task && task.filter) {
    el = task.filter('.field').get(0)
  }
  if (!el || el.nodeType !== 1) return
  $container.packery('bindDraggabillyEvents', new Draggabilly(el, {
    handle: '.draggable-handle'
  }))
}

function layoutBoardingTemplate ($container) {
  if (!$container.data('packery')) return
  $container.packery('layout')
}

function initDraggabelBoardingTemplate ($container) {
  if ($container.data('packery')) return
  $container.packery({ itemSelector: '.field' })
  // init draggabilly
  $container.packery('getItemElements').forEach((task) => initDraggabelBoardingTask(task, $container))
  // Update position field after drag
  $container.packery('on', 'dragItemPositioned', () => updateTasksPositionOrder($container))
}

function setupResponsiveBoardingTemplateLayout () {
  const layout = document.querySelector('.boarding-template-form__layout')
  const entries = layout?.querySelector('.boarding-template-form__entries')
  const availableTasks = layout?.querySelector('.boarding-template-form__available-tasks')
  if (!entries || !availableTasks) return

  const mobileLayout = window.matchMedia('(max-width: 1024.98px)')
  const updateLayout = () => {
    const firstSection = mobileLayout.matches ? availableTasks : entries
    if (layout.firstElementChild !== firstSection) layout.insertBefore(firstSection, layout.firstElementChild)
  }
  const removeListener = () => mobileLayout.removeEventListener('change', updateLayout)

  updateLayout()
  mobileLayout.addEventListener('change', updateLayout)
  document.addEventListener('turbo:before-cache', removeListener, { once: true })
}

function setupBoardingTemplateForm () {
  const boardingTemplateTaskAssociationLinks = $('a.add_template_task')
  const boardingTemplateTasksContainer = $('#boarding_template_entries')

  // Prevent duplicate Packery/Draggabilly initializations and Cocoon handlers.
  if (boardingTemplateTasksContainer.data('boarding-template-setup')) return
  boardingTemplateTasksContainer.data('boarding-template-setup', true)

  setupResponsiveBoardingTemplateLayout()
  initDraggabelBoardingTemplate(boardingTemplateTasksContainer)

  // Packery measures item heights at turbo:render, before turbo:load handlers
  // such as select2 init, icon mounts, and webfonts have finished. Re-layout
  // once the DOM has reached its final rendered height.
  window.requestAnimationFrame(() => layoutBoardingTemplate(boardingTemplateTasksContainer))
  document.fonts?.ready?.then(() => layoutBoardingTemplate(boardingTemplateTasksContainer))

  boardingTemplateTaskAssociationLinks
    .data('association-insertion-method', 'append')
    .data('association-insertion-node', () => boardingTemplateTasksContainer)

  boardingTemplateTasksContainer
    .on('cocoon:before-insert', (event, task) => {
      const newField = task.filter('.field')
      const taskId = newField.data('task')
      const activeTaskExists = boardingTemplateTasksContainer
        .children(`.field[data-task='${taskId}']`)
        .toArray()
        .some((field) => $(field).find("input[name$='[_destroy]']").val() !== '1')

      if (activeTaskExists) event.preventDefault()
    })
    .on('cocoon:after-insert', (e, task) => {
      ReactOnRails.reactOnRailsPageLoaded()
      const newField = task.filter('.field')
      $(boardingTemplateTasksContainer).find('label.checkbox').each((i, el) => {
        if ($(el).find('span.box').length === 0) $(el).append('<span class="box"></span>')
      })
      $('#template_task_' + newField.data('task')).parents('.field').addClass('hidden')
      window.Forms.initSelect2(newField)
      boardingTemplateTasksContainer.packery('appended', newField)
      initDraggabelBoardingTask(newField, boardingTemplateTasksContainer)
    })
    .on('cocoon:after-remove', (e, task) => {
      $('#template_task_' + task.data('task')).parents('.field').removeClass('hidden')
      boardingTemplateTasksContainer.packery('layout')
    })
}

window['companies/boarding/templates#new'] = setupBoardingTemplateForm
window['companies/boarding/templates#edit'] = setupBoardingTemplateForm

window['companies/boarding/templates#index'] = () => {
  const templatesSearchForm = $('.boarding_template form')
  const templatesTable = $('#boarding-templates-table')
  const templatesSearchInput = $('#q_translations_title_cont')

  const loadTemplates = () => templatesSearchForm.submit()
  const lazyLoadTemplates = _.debounce(loadTemplates, 600)

  templatesSearchForm.on('submit', () => templatesTable.html('<span class="loading sm"/>'))
  templatesSearchInput.on('keyup change', lazyLoadTemplates)
}
